import { createAction, createAsyncAction } from "typesafe-actions";
import type { FetchError } from "app/pages/sales-intelligence/types";
import type { CompetitiveLandscapeResults } from "../types/dto";

export const tableRowsSelectionToggledAction = createAction(
    "@@si/account-overview/competitive-landscape-rows-selection-toggled",
)<boolean>();

export const fetchResultsAsync = createAsyncAction(
    "@@si/account-overview/competitive-landscape-results-fetch-started",
    "@@si/account-overview/competitive-landscape-results-fetch-succeeded",
    "@@si/account-overview/competitive-landscape-results-fetch-failed",
)<void, CompetitiveLandscapeResults, FetchError>();

export const downloadAsExcelAsync = createAsyncAction(
    "@@si/account-overview/competitive-landscape-download-as-excel-started",
    "@@si/account-overview/competitive-landscape-download-as-excel-succeeded",
    "@@si/account-overview/competitive-landscape-download-as-excel-failed",
)<void, void, FetchError>();
